'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageEditController = function () {
  function ImageEditController(ImagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ImageEditController);
    this.image = {};
    this.Upload = Upload;
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.existRecord = 0;
    var vm = this;
    ImagesDataProvider.loadCategoriesNoLimit().then(function (result) {
      vm.mainCategories = result;
    });
    ImagesDataProvider.getImage(vm.$state.params.id).then(function (result) {
      vm.image = result;
      vm.image.img = APPLICATION_URL + '/' + result.path;
      vm.image.oldPath = result.path;
    });
  }

  (0, _createClass3.default)(ImageEditController, [{
    key: 'onvertToSlug',
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: 'saveData',
    value: function saveData(form) {
      var vm = this;
      if (!form) {
        return false;
      }
      vm.__loading = true;
      if (vm.image.name) vm.image.slug = vm.onvertToSlug(vm.image.name);
      var file = vm.image.img;
      var data = {};
      data.name = vm.image.name;
      data.id = vm.image.image_id;
      data.slug = vm.onvertToSlug(vm.image.name);
      data.image_category_id = vm.image.image_category_id;
      if (file.name != undefined) {
        //check image exist or not
        var chkData = { name: data.name, slug: data.slug, id: data.id };
        vm.ImagesDataProvider.checkRecordExist(chkData).then(function (res) {
          if (res.exist == 0) {
            file.upload = vm.Upload.upload({
              url: vm.APPLICATION_URL + '/api/upload',
              method: 'POST',
              data: { 'image': file, 'max-w': '1200', 'max-h': '600' }
            });
            file.upload.then(function (response) {
              data.filename = new Date().valueOf() + file.name;
              data.response = response.data;
              data.oldPath = vm.image.oldPath;
              data.mime_type = file.type;
              vm.ImagesDataProvider.updateImageData(data).then(function (response) {
                vm.$timeout(function () {
                  vm.$state.go('app.images');
                }, 5000);
              });
            }, function (response) {
              if (response.status > 0) alert(response.status + ': ' + response.data);
              vm.__loading = false;
            });
          } else {
            vm.existRecord = 1;
            vm.__loading = false;
          }
        });
      } else {
        vm.ImagesDataProvider.updateData(data).then(function (response) {
          if (response.exist == 0) {
            vm.$state.go('app.images');
          } else {
            vm.__loading = false;
            vm.existRecord = 1;
          }
        });
      }
    }
  }, {
    key: 'change',
    value: function change(file) {
      this.image.name = file.name.replace(/\.[^/.]+$/, "");
    }
  }]);
  return ImageEditController;
}();

// WEBPACK FOOTER //


exports.default = ImageEditController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/edit/controller.js
 **/